import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { isMobileOnly } from 'react-device-detect'
import { useUser } from '@/utils/hooks'
import { InfoBox, SettingsWrapper } from '../components/common'
import { useModuleConfigs } from '../hooks'
import { ExportAbsences } from './export-absences'
import { ExportActivities } from './export-activities'
import { ExportDriverGrades } from './export-driver-grades'
import { ExportFleetTaxZone } from './export-fleet-tax-zone'
import { ExportInfringements } from './export-infringements'
import { ExportIssues } from './export-issues'
import { ExportTimesheets } from './export-timesheets'

interface ExportsSettingsSettingsProps {}

export const ExportsSettings: React.FC<ExportsSettingsSettingsProps> = () => {
  const translations = useTranslate({
    info1: 'settings.info.exports-1',
  })

  const { active } = useModuleConfigs()
  const user = useUser()

  return (
    <SettingsWrapper
      grid={{
        flow: 'row',
      }}
    >
      <InfoBox initCollapsed={isMobileOnly}>
        <p>{translations.info1}</p>
      </InfoBox>

      {active.activities && <ExportActivities />}

      {active.issues && <ExportIssues />}

      {active.infringements && <ExportInfringements />}

      {active.timesheets && <ExportTimesheets />}

      {active.absences && <ExportAbsences />}

      {active.activities && <ExportDriverGrades />}

      {active.fleet && user.isSuperuser && <ExportFleetTaxZone />}
    </SettingsWrapper>
  )
}
